import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d367477"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qualitychecksafe-container" }
const _hoisted_2 = { class: "button" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("开始巡检")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["title", "onClickLeft"]),
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.submitform.title) = $event)),
            rules: [{ required: true, message: '巡检名称必填' }],
            required: "",
            label: "巡检名称",
            placeholder: "请填写巡检名称",
            maxlength: "50"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.typename,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typename) = $event)),
            rules: [{ required: true, message: '巡检类型必填' }],
            "is-link": "",
            required: "",
            readonly: "",
            clickable: "",
            label: "巡检类型",
            placeholder: "请选择类型",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.typePicker = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_popup, {
            show: _ctx.typePicker,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.typePicker) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                columns: _ctx.typePickerscolumns,
                "show-toolbar": "",
                "value-key": "name",
                onConfirm: _ctx.typePickersonConfirm,
                onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.typePicker = false))
              }, null, 8, ["columns", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.deviceName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.deviceName) = $event)),
            rules: [{ required: true, message: '巡检设备必填' }],
            "is-link": "",
            required: "",
            readonly: "",
            clickable: "",
            label: "巡检设备",
            placeholder: "请选择设备",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.devicePicker = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_popup, {
            show: _ctx.devicePicker,
            "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.devicePicker) = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                columns: _ctx.devicePickerscolumns,
                "show-toolbar": "",
                "value-key": "deviceName",
                onConfirm: _ctx.devicePickersonConfirm,
                onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.devicePicker = false))
              }, null, 8, ["columns", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.submitform.description,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.submitform.description) = $event)),
            rows: "2",
            autosize: "",
            label: "巡检描述",
            type: "textarea",
            placeholder: "请填写巡检描述",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_button, {
            loading: _ctx.isLoad,
            block: "",
            disabled: _ctx.flag,
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}